export default __webpack_public_path__ + "static/media/Whisperstride.8f4d8b96.jpg";